module.exports = __webpack_public_path__ + "static/media/prev.41d04e6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/prev.png
// module id = 168
// module chunks = 0